import React, { Component } from 'react';
import {
  // imageBasePath,
  // isDevelopment
} from '../../library/constants';
import {
  isMobileTablet,
} from '../../library/calc';

class CornerMessage extends Component {

  render () {

    // const {
    //   switchTree,
    //   canvasHeight,
    // } = this.props;

    const genericStyles = {
      right: `7px`,
      top: `10px`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `55px`,
      fontSize: `${ isMobileTablet() ? 16: 13 }px`,
      backgroundColor: 'white',
      backgroundPosition: '2px 2px',
      border: '1px solid #C0C0C0',
      width: `auto`,
      height: `${ isMobileTablet() ? 44: 38 }px`,
      position: 'absolute',
      boxSizing: 'border-box',
      padding: '10px',
      opacity: .7,
      cursor: 'pointer',
      MozBoxShadow: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
      webKitboxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
      boxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
    }

    let cornerMessageStyle = {
      background: `white`,
      ...genericStyles,
    };

    return (
      <div >
        <div
          id={'CornerMessageDiv'}
          style={cornerMessageStyle}
          >
          Direct ancestors only mode.  <a
            onClick={
              ()=>{

                let postObj = {
                  callback: () => {
                    window.location.reload();
                  },
                  skipReloadCanvasTree: true,
                  show_ancestors: 0,
                };

                this.props.postPreferences(postObj)

              }}

            onTouchStart={(event)=>{

                let postObj = {
                  callback: () => {
                    window.location.reload();
                  },
                  skipReloadCanvasTree: true,
                  show_ancestors: 0,
                };

                this.props.postPreferences(postObj)
            }}

          ><u>Show all profiles</u></a>
        </div>
      </div>
    );
  }
}

export default CornerMessage;
